import { Edit, RemoveCircleOutline, Search } from '@mui/icons-material'
import React, { useEffect, useState, useRef } from 'react';
import { Button, Chip, Dialog, DialogActions, DialogTitle, FormControl, Grid, InputLabel, MenuItem, Pagination, Paper, Select, Table, TableBody, TableCell, TableHead, TableRow, TextField, Tooltip } from '@mui/material';
import { styled } from '@mui/system'
import "./networks.css"
import { useNavigate } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify'
import Loader from '../../components/Loader/Loader'
import Toptag from '../../components/toptag/Toptag'
import apiFunctions from '../../api/apiFunctions'


const NavPaper = styled(Paper)({
    padding: "5px 12px",
    borderRadius: "0",
    backgroundColor: "white",
    boxShadow: "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px"
})

const BackPaper = styled(Paper)({
    minHeight: "calc(100vh - 130px)",
    overflow: "visible",
    boxShadow: "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px"
})

export default function Networks() {

    const [all, setAll] = useState([]);
    const [isLoading, setIsloading] = useState(true)
    const [networksCount, setNetworksCount] = useState(0)
    const navigate = useNavigate();
    const [limit, setLimit] = useState(5);
    const [skip, setSkip] = useState('0');
    const [page, setPage] = useState("1")
    const [searchKey, setSearchKey] = useState("");
    const [debouncedSearchKey, setDebouncedSearchKey] = useState("");
    const [isActiveFilter, setIsActiveFilter] = useState("");
    const [networkTypeFilter, setNetworkTypeFilter] = useState("");
    const [openDialogForRemove, setOpenDialogForRemove] = React.useState(false);
    const [id, setId] = useState()
    const debounceTimerRef = useRef(null);


    const handleRemoveOpen = (id) => {
        setId(id)
        setOpenDialogForRemove(true);
    };

    const handleRemoveClose = () => {
        setOpenDialogForRemove(false);
    };

    const searchHandle = (event) => {
        const newQuery = event.target.value;
        setSearchKey(newQuery)
        setSkip(0);
        setPage(1);

        if (debounceTimerRef.current) {
            clearTimeout(debounceTimerRef.current);
        }

        debounceTimerRef.current = setTimeout(() => {
            setDebouncedSearchKey(newQuery);
        }, 500);
    }

    const handleCreateOpen = () => {
        navigate("/home/networks/add");
    };

    const handleEditOpen = (network) => {
        navigate("/home/networks/edit", { state: { id: network._id } });
    };

    const getAll = async () => {
        setIsloading(true);
        let result = await apiFunctions.getAllNetworks(limit, debouncedSearchKey, page, isActiveFilter, networkTypeFilter);
        if (!result.data.status) {
            if (result.data.code === 401) {
                localStorage.clear();
                navigate("/login")
                toast.info("Session Expired Please login again!!")
            }
            toast.error(result.data.message, {
                position: toast.POSITION.TOP_RIGHT
            });
            setIsloading(false)
        } else {
            setAll(result.data.data);
            setNetworksCount(result.data.total_count)
            setIsloading(false)
        }
    }

    useEffect(() => {
        getAll()
    }, [debouncedSearchKey, limit, page, isActiveFilter, networkTypeFilter])

    useEffect(() => {
        return () => {
            if (debounceTimerRef.current) {
                clearTimeout(debounceTimerRef.current);
            }
        };
    }, [])

    const removeNetwork = async (id) => {
        const result = await apiFunctions.removeNetwork(id);
        if (!result.data.status) {
            if (result.data.code === 401) {
                localStorage.clear();
                navigate("/login")
                toast.info("Session Expired Please login again!!")
            }
            toast.error(result.data.message, {
                position: toast.POSITION.TOP_RIGHT
            });
        } else {
            setOpenDialogForRemove(false);
            getAll();
            toast.success(result.data.message, {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    }

    const handleChange = (e) => {
        const v = Number(e.target.value)   // Select returns a string; coerce so "All" matches
        if (v === networksCount) {
            setSkip(0)
            setLimit(networksCount)
        } else {
            setLimit(v)
        }
    };

    const skipPagination = (e, page) => {
        setSkip((page - 1) * limit)
        setPage(page)
    }

    return (
        <>
            <div className='container'>
                        <Toptag />
                        <ToastContainer autoClose={1000} />
                        <NavPaper>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <div></div>
                                <Grid container spacing={4} direction="row" justifyContent="flex-end" alignItems="center">
                                    <Grid item><div style={{ fontSize: "15px", fontWeight: "400", color: "grey" }}>Total Networks - {networksCount}</div></Grid>
                                    <Grid item><div style={{ fontSize: "15px", fontWeight: "400", color: "grey" }}>Row Per Page - </div></Grid>
                                    <Grid item>
                                        <FormControl variant="standard" sx={{ m: 1, minWidth: 50 }}>
                                            <Select
                                                labelId="demo-simple-select-standard-label"
                                                id="demo-simple-select-standard-label"
                                                value={limit}
                                                onChange={handleChange}
                                            >
                                                <MenuItem value="5">5</MenuItem>
                                                <MenuItem value="10">10</MenuItem>
                                                <MenuItem value="20">20</MenuItem>
                                                <MenuItem value="30">30</MenuItem>
                                                <MenuItem value={networksCount}>All</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item>
                                        <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                                            <InputLabel>Status</InputLabel>
                                            <Select
                                                value={isActiveFilter}
                                                onChange={(e) => {
                                                    setIsActiveFilter(e.target.value);
                                                    setPage(1);
                                                }}
                                                label="Status"
                                            >
                                                <MenuItem value="">All</MenuItem>
                                                <MenuItem value="true">Active</MenuItem>
                                                <MenuItem value="false">Inactive</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item>
                                        <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                                            <InputLabel>Type</InputLabel>
                                            <Select
                                                value={networkTypeFilter}
                                                onChange={(e) => {
                                                    setNetworkTypeFilter(e.target.value);
                                                    setPage(1);
                                                }}
                                                label="Type"
                                            >
                                                <MenuItem value="">All</MenuItem>
                                                <MenuItem value="mainnet">Mainnet</MenuItem>
                                                <MenuItem value="testnet">Testnet</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item>
                                        <div className='searchBar'>
                                            <input type="text" placeholder='Search... ' onChange={searchHandle} id='searchtext' className='searchBarInput' />
                                            <Search className='searchIcon' />
                                        </div>
                                    </Grid>
                                    <Grid item>
                                        <button className='newBtn' onClick={handleCreateOpen}>Add Network</button>
                                    </Grid>
                                </Grid>

                            </div>
                        </NavPaper>
                        {isLoading ? (
                    <Loader />) : (
                    <>
                        <BackPaper>
                            {all.length === 0 && debouncedSearchKey ?
                                <Grid container spacing={2} style={{ marginTop: "30px" }} direction="column" justifyContent="space-evenly" alignItems="center">
                                    <Grid item><img src="/images/nodata.jpg" alt="error-image" style={{ height: "150px", width: "200px" }} /></Grid>
                                    <Grid item><div className="errorMessage">Networks not found!</div></Grid>
                                </Grid> :
                                <>
                                    <Table stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>S.No</TableCell>
                                                <TableCell>Name</TableCell>
                                                <TableCell>Chain ID</TableCell>
                                                <TableCell>Network Type</TableCell>
                                                <TableCell>Native Currency</TableCell>
                                                <TableCell>Status</TableCell>
                                                <TableCell>Created Since</TableCell>
                                                <TableCell align="center">Action</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>

                                            {all.map((element, index) => {
                                                let date = new Date(element.createdAt);
                                                let monthsArray = ["Jan", "Feb", "March", "Apr", "May", "Jun", "July", "Aug", "Sept", "Oct", "Nov", "Dec",];
                                                let joinedSince = `${date.getDate()} ${monthsArray[date.getMonth()]} ${date.getFullYear()}`
                                                return (<>
                                                    <TableRow key={index + 1}>
                                                        <TableCell>{index + 1}</TableCell>
                                                        <TableCell>{element.name}</TableCell>
                                                        <TableCell>{element.chain_id}</TableCell>
                                                        <TableCell>
                                                            <Chip 
                                                                label={element.network_type} 
                                                                className={element.network_type === 'mainnet' ? "statusChipActive" : "statusChipPr"}
                                                                size="small"
                                                            />
                                                        </TableCell>
                                                        <TableCell>{element.native_currency_symbol}</TableCell>
                                                        <TableCell>
                                                            {element.is_active === true ? (
                                                                <Chip label="Active" className="statusChipActive" />
                                                            ) : (
                                                                <Chip label="Inactive" className="statusChipBlock" />
                                                            )}
                                                        </TableCell>
                                                        <TableCell>{joinedSince}</TableCell>
                                                        <TableCell>
                                                            <Grid container spacing={1} direction="row" justifyContent="center" alignItems="center">
                                                                <Grid item>
                                                                    <Tooltip title="Edit Network" >
                                                                        <Edit className='visibilityIc' onClick={() => { handleEditOpen(element) }} />
                                                                    </Tooltip>
                                                                </Grid>
                                                                <Grid item>
                                                                    {element.isDeleted === false ?
                                                                        <Tooltip title="Delete Network" >
                                                                            <RemoveCircleOutline className="userListDelete" onClick={() => { handleRemoveOpen(element._id) }} />
                                                                        </Tooltip>
                                                                        : null}
                                                                </Grid>
                                                            </Grid>
                                                        </TableCell>
                                                    </TableRow>
                                                </>
                                                )
                                            })}
                                        </TableBody>
                                    </Table>
                                </>
                            }

                            <Dialog open={openDialogForRemove} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                                <DialogTitle id="alert-dialog-title">
                                    {"Are you sure want to remove this Network?"}
                                </DialogTitle>
                                <DialogActions>
                                    <Button onClick={handleRemoveClose}>No</Button>
                                    <Button onClick={() => { removeNetwork(id) }} >Yes</Button>
                                </DialogActions>
                            </Dialog>

                            <div style={{ display: 'flex', flexDirection: "row", justifyContent: "center", alignItems: 'center', marginTop: "20px", marginBottom: "20px" }}>
                                <div>
                                    <Pagination count={Math.ceil(networksCount / limit)} page={Math.floor(skip / limit) + 1} variant="outlined" onChange={skipPagination} shape="rounded" />
                                </div>
                            </div>
                        </BackPaper>

                    </>
                )}
            </div>
        </>
    )
}
